export const EmployeeSearchCriteriaList: Array<{
  label: string;
  value: string;
}> = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'skill-id',
    label: 'Skills',
  },
  {
    value: 'employee-name',
    label: 'Employee Name',
  },
  {
    value: 'mobile',
    label: 'Mobile Number',
  },
  {
    value: 'email',
    label: 'Email',
  },
  {
    value: 'total_year_of_experience',
    label: 'Total Experience',
  },
];

export const ProfileSearchCriteriaList: Array<{
  label: string;
  value: string;
}> = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'employee-name',
    label: 'Employee Name',
  },
  {
    value: 'mobile',
    label: 'Mobile Number',
  },
  {
    value: 'email',
    label: 'Email',
  },
  {
    value: 'resource_engaged',
    label: 'Resource Engaged',
  },
];

export const SkillSearchCriteriaList: Array<{
  label: string;
  value: string;
}> = [
  {
    value: 'all',
    label: 'All',
  },
  {
    value: 'skill-category list',
    label: 'Skill Category',
  },
  {
    value: 'skill-name',
    label: 'Skill Name',
  },
  {
    value: 'skill_types',
    label: 'Skill Type',
  },
];
